import React, { FC, useState } from 'react';
import {
	dateFormatter,
	DATE_FORMAT,
	optionalFilter,
	BLACKS_AND_WHITES,
} from '../../utils/DataFormatterUtils';
import {
	getPrimaryColor,
	getWorkOrderTimeZoneId,
	nullSafeGet,
	nullSafeGetOrElse,
} from '../../utils/DataAccessUtils';
import { QUOTE_STATUS_DISPLAY_NAMES } from '../../constants/QuoteStatuses';
import { UserName } from '../name_component/user/UserNameComponent';
import LocationName from '../name_component/location/LocationNameComponent';
import DetailRow from '../detail_row/DetailRow';
import { Col, Row } from 'antd';
import DateTimeHover from '../date_time_component/DateTime';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import {
	getQuoteOtherCompany,
	getQuoteSubmittedAt,
	getQuoteSubmittedContact,
} from '../quote_utils/QuoteUtils';

const QuotesAdditionalDetails: FC<any> = ({
	quote,
	lastQuote = {},
	passthroughItems = [],
	userType,
	currentUser,
	showComparison,
}): React.ReactElement => {
	const [showAll, setShowAll] = useState(false);
	const submittedContact = getQuoteSubmittedContact(quote);
	const submittedTime = getQuoteSubmittedAt(quote);
	const detailItems = [
		{ key: 'Status', value: QUOTE_STATUS_DISPLAY_NAMES[quote.status] },
		{
			key: 'Work Order #',
			value: optionalFilter(
				nullSafeGet('workOrderId', quote)
					? `${nullSafeGet('workOrderId', quote)}`
					: nullSafeGet('workOrder.id', quote)
					? nullSafeGet('workOrder.id', quote)
					: null
			),
		},
		{
			key: 'Location',
			value: nullSafeGet('workOrder.location', quote) ? (
				<LocationName
					location={nullSafeGet('workOrder.location', quote)}
					mode="container"
					underline
					placement="top"
				/>
			) : null,
		},
		{ key: 'Quote #', value: optionalFilter(nullSafeGetOrElse('quoteNumber', quote, quote.id)) },
		submittedContact
			? {
					key: 'Submitted By',
					value: <UserName contact={submittedContact} mode={'inline'} placement={'top'} />,
			  }
			: {},
		submittedTime
			? {
					key: 'Submitted',
					value: (
						<DateTimeHover
							timestamp={submittedTime}
							timeZone={getWorkOrderTimeZoneId(nullSafeGet('workOrder', quote))}
						/>
					),
			  }
			: {},
		...passthroughItems,
	];

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				gap: 20,
				width: '100%',
				marginBottom: '20px',
			}}
		>
			<Row>{getQuoteOtherCompany(quote, currentUser)}</Row>
			{nullSafeGetOrElse('scope.length', lastQuote, 0) > 0 &&
			nullSafeGet('scope', quote) !== nullSafeGet('scope', lastQuote) &&
			showComparison ? (
				<div style={{ padding: 0 }} className="materialCard__body">
					<div className="materialCard__primaryTitle">
						<div
							style={{
								fontSize: 16,
								textDecoration: 'line-through',
								color: BLACKS_AND_WHITES.blackSecondary,
								...(showAll
									? {}
									: {
											display: '-webkit-box',
											WebkitLineClamp: 5,
											WebkitBoxOrient: 'vertical',
											overflow: 'hidden',
									  }),
							}}
							className="richTextWrapper"
							dangerouslySetInnerHTML={{ __html: lastQuote.scope }}
						/>
						<span
							style={{
								color: getPrimaryColor(userType),
								cursor: 'pointer',
							}}
							onClick={() => setShowAll(!showAll)}
						>
							{showAll ? 'Show Less' : 'Show More'}
						</span>
					</div>
				</div>
			) : null}
			{nullSafeGet('scope', quote) ? (
				<div
					style={{ fontSize: 16 }}
					className="richTextWrapper"
					dangerouslySetInnerHTML={{ __html: quote.scope }}
				/>
			) : null}
			<DetailRow details={detailItems} />
		</div>
	);
};

const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch, ownProps) => ({});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(QuotesAdditionalDetails)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
